import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { AgentCategorySearchDto } from '../../agent-categories';

/**
 * Resolved related records for an agent activity event, keyed by relation.
 */
export class AgentActivityEventHydration {
  agentCategory?: ActivityFieldHydration<AgentCategorySearchDto>;
  link?: ActivityLinkHydration;
}
